// removed by extract-text-webpack-plugin
module.exports = {"drop":"drop","dragEnter":"dragEnter"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/sass/Layout/Drop.scss
// module id = 241
// module chunks = 0